import styled, { css, Scale, StyledComponent } from '@se-admin/falcon';

export const RightColumnItem: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    margin-bottom: ${Scale.m};
  `;
});

export const CenteredCardContent: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    text-align: center;
  `;
});

export const CenteredCardContentItem: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    display: inline-block;
  `;
});

export const CenteredCardContentButton: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    display: inline-block;
    margin-top: ${Scale.xs};
  `;
});
